import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Invoices from './components/Invoices';

const invoices = (props, { t }) => (
  <Container>
    <Invoices {...props} />
  </Container>
);

invoices.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(invoices);
